import { r as registerInstance, h } from './index-16dc7dde.js';
import './lookups-705fb53e.js';
import { g as CountrySelectorConstants } from './request.constants-deb285e0.js';
import { s as send, f as csExitToSchneiderEvent } from './send-33ade633.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import './analytics-765d4daf.js';
import './_commonjsHelpers-ba3f0406.js';
import './utils-913bdf8a.js';

let CountrySelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.country_code = CountrySelectorConstants.COUNTRY_CODE;
    this.language_code = CountrySelectorConstants.LANGUAGE_CODE;
    this.not_scoped_message = CountrySelectorConstants.NOT_SCOPED_MESSAGE;
    this.toggle_click = CountrySelectorConstants.TOGGLE_CLICK;
    this.app_source = CountrySelectorConstants.APP_SOURCE;
    this.cs_endPoint = `${window.countrySelectorHost}${CountrySelectorConstants.CS_ENDPOINT}`;
    this.onCountryLabelClicked = (event) => {
      const selectedCountry = this.countriesData.find((ele) => ele.locale === event.detail.locale);
      const { url = '' } = selectedCountry;
      send(csExitToSchneiderEvent, { link_url: `${window.location.origin}${url}` });
      document.location.href = url;
    };
  }
  componentWillLoad() {
    var _a, _b;
    const countries = (_a = tryParse(this._countriesData)) !== null && _a !== void 0 ? _a : this.countriesData;
    const messages = (_b = tryParse(this._countriesMessages)) !== null && _b !== void 0 ? _b : this.countriesMessages;
    this.not_scoped_message = messages.empty || CountrySelectorConstants.NOT_SCOPED_MESSAGE;
    this.cs_title = messages.success;
    let locations = '';
    const localesList = [];
    countries.forEach((element) => {
      const { code = '', lang = '' } = element;
      const locale = `${lang}_${code.toLowerCase()}`;
      element.locale = locale;
      localesList.push(locale);
    });
    this.countriesData = countries;
    locations = localesList.join(',');
    this.locales = locations;
  }
  render() {
    return (h("div", { class: "pes-country-selector-content" }, h("country-selector", { cs_endpoint: this.cs_endPoint, country_code: this.country_code, language_code: this.language_code, app_source: this.app_source, ref: () => {
        window.addEventListener('countryLabelClicked', this.onCountryLabelClicked);
      }, locales: this.locales, cs_title: this.cs_title, not_scoped_message: this.not_scoped_message, toggle_click: this.toggle_click })));
  }
};

export { CountrySelector as pes_country_selector };
